import React, { useRef } from "react";
import Head from "next/head";
import Cookies from "js-cookie";
import { useEffect, useState, useCallback } from "react";
import { useRouter } from "next/router";
import Layout from "../components/Layout";
import HeaderContent from "../components/home/HeaderContent";
import Orders from "../components/orders/orders";
import axiosInstance from "../config/axios";
import Router from "next/router";
import Image from "next/image";
import useInView from "../hooks/useInView";
import { PostCard } from "../pages/blog/index.js";
import { axiosInstanceV2 } from "../config/axios";
import {
  fetchBlogs,
  formatBlogDate,
  shortenExcerpt,
} from "../helpers/blogUtils";

const TAGS = [
  { icon: "/images/icon/nigerian-meals.svg", label: "Nigerian Meals" },
  { icon: "/images/icon/jollof-rice.svg", label: "Jollof Rice" },
  { icon: "/images/icon/fried-rice.svg", label: "Fried Rice" },
  { icon: "/images/icon/grilled-chicken.svg", label: "Grilled Chicken" },
  { icon: "/images/icon/shawarma.svg", label: "Shawarma" },
  { icon: "/images/icon/swallows-and-soups.svg", label: "Swallows & Soups" },
  { icon: "/images/icon/pastries.svg", label: "Pastries" },
  { icon: "/images/icon/affordable-meals.svg", label: "Affordable Meals" },
  { icon: "/images/icon/order-food-online.svg", label: "Order Food Online" },
  { icon: "/images/icon/food-delivery.svg", label: "Food Delivery" },
  { icon: "/images/icon/pickup.svg", label: "Pickup" },
  {
    icon: "/images/icon/restaurants-near-you.svg",
    label: "Restaurants Near You",
  },
];
const MENU_ITEMS = [
  { id: 1, name: "Jollof Rice", image: "/images/jollof-rice-rd.webp" },
  { id: 2, name: "Fried Rice", image: "/images/fried-rice-rd.webp" },
  { id: 3, name: "Burger", image: "/images/burger-rd.webp" },
  { id: 4, name: "Pasta", image: "/images/pasta-rd.webp" },
  { id: 5, name: "Shawarma", image: "/images/sharwama-rd.webp" },
  { id: 6, name: "Dodo", image: "/images/dodo-rd.webp" },
  { id: 7, name: "Chicken", image: "/images/grilled-chicken-rd.webp" },
  { id: 8, name: "Edikaikong", image: "/images/edikaikong-rd.webp" },
  { id: 9, name: "Moi Moi", image: "/images/moi-moi-rd.webp" },
  { id: 10, name: "Meat Pie", image: "/images/meatpie-rd.webp" },
  { id: 11, name: "Turkey", image: "/images/turkey-rd.webp" },
  { id: 12, name: "Yam Pottage", image: "/images/yam-pottage-rd.webp" },
  { id: 13, name: "Doughnut", image: "/images/doughnut.webp" },
];

const Home = () => {
  const [cities, setCities] = useState([]);
  const [loadingCities, setLoadingCities] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [foodBannerRef, foodBannerInView] = useInView("Food Banner");
  const [blogs, setBlogs] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [animating, setAnimating] = useState(false);
    const [displayIndex, setDisplayIndex] = useState(0);

    
  const current = MENU_ITEMS[displayIndex];
    useEffect(() => {
      const interval = setInterval(() => {
        // trigger exit animation
        setAnimating(true);
  
        // after exit animation completes, swap image and trigger enter
        setTimeout(() => {
          setDisplayIndex((prev) => (prev + 1) % MENU_ITEMS.length);
          setCurrentIndex((prev) => (prev + 1) % MENU_ITEMS.length);
          setAnimating(false);
        }, 400); // matches the exit animation duration
      }, 3000); // swap every 3 seconds
  
      return () => clearInterval(interval);
    }, []);

  const trackRef = useRef(null);

  const handleMouseEnter = () => {
    if (trackRef.current) {
      trackRef.current.style.animationPlayState = "paused";
    }
  };

  const handleMouseLeave = () => {
    if (trackRef.current) {
      trackRef.current.style.animationPlayState = "running";
    }
  };

  // duplicate items so the loop is seamless
  const items = [...MENU_ITEMS, ...MENU_ITEMS];
  useEffect(() => {
    const fetchCities = async () => {
      try {
        const {
          data: { data },
        } = await axiosInstance.get("cities");

        setCities(data);
      } catch (err) {
        console.error(err);
      } finally {
        setLoadingCities(false);
      }
    };

    fetchCities();
  }, []);
  const loadBlogs = useCallback(async () => {
    try {
      const data = await fetchBlogs();

      setBlogs(data ?? []);
    } catch (error) {
      console.error("Failed to fetch blogs", error);
      setBlogs([]);
    } finally {
    }
  }, []);

  useEffect(() => {
    loadBlogs();
  }, []);

  useEffect(() => {
    localStorage.setItem("setAllCities", JSON.stringify(cities));
    if (
      Cookies.set("couponAmt") ||
      Cookies.set("coupName") ||
      Cookies.set("totalPriceAmtWithCoupon") ||
      Cookies.set("unusedBalance") ||
      Cookies.set("newUnusedBalance")
    ) {
      Cookies.remove("unusedBalance");
      Cookies.remove("couponAmt");
      Cookies.remove("totalPriceAmtWithCoupon");
      Cookies.remove("coupName");
      Cookies.remove("newUnusedBalance");
    }
  }, [cities]);

  useEffect(() => {
    if (typeof window !== "undefined" && typeof $ !== "undefined") {
      window.$ = $;

      $(window).scroll(function () {
        var scroll = $(window).scrollTop();

        if (scroll >= 900) {
          $(".app-img-1").addClass("animate-1");
          $(".app-img-2").addClass("animate-2");
        } else {
          $(".app-img-1").removeClass("animate-1");
          $(".app-img-2").removeClass("animate-2");
        }
      });

      window.$ = $;
      $(window).ready(function () {
        const $el = $("html, body");
        $el.css({ "overflow-x": "hidden" });
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
      });
    }

    // Scroll to the top
  }, []);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 768); // Bootstrap md breakpoint
    };

    // Check on initial load
    checkScreenSize();

    // Listen for window resize
    window.addEventListener("resize", checkScreenSize);

    return () => {
      window.removeEventListener("resize", checkScreenSize);
    };
  }, []);

  const routeToWallet = (event) => {
    event.preventDefault();
    event.stopPropagation();

    Router.push("/wallet");
  };
  const routeToGiftcard = (event) => {
    event.preventDefault();
    event.stopPropagation();

    Router.push("/giftcard");
  };
  const routeToLocation = (event) => {
    event.preventDefault();
    event.stopPropagation();

    Router.push("/store-location");
  };

  const router = useRouter();

  const canonicalUrl = `https://kilimanjaro-restaurants.com${router.asPath.split("?")[0]}`;

  return (
    <>
      <Layout showSecFooter>
        <Head>
          {/* <link href="https://fonts.googleapis.com/css2?family=UnifrakturMaguntia&display=swap" rel="stylesheet"></link>
        <link href="https://fonts.googleapis.com/css2?family=Syne+Mono&display=swap" rel="stylesheet"></link> */}
          <link rel="canonical" href={canonicalUrl} />
          <title>
            Order Food Online, Delivery, Pickup & Dine-In | Kilimanjaro
            Restaurant
          </title>
          <meta name="viewport" content="width=device-width, initial-scale=1" />
          <meta
            name="description"
            content="Order your favourite meals from Kilimanjaro restaurant for delivery or pickup, or enjoy them dine-in. Choose from jollof rice, fried rice, chicken, shawarma, swallows and more."
          />

          <meta name="keyword" content="MEALS FOOD RESTAURANT NIGERIA" />
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify({
                "@context": "https://schema.org",
                "@type": "WebSite",
                url: "https://kilimanjaro-restaurants.com",
                name: "Kilimanjaro",
                description:
                  "Kilimanjaro is one of the Sundry Foods’ restaurant brands, operating in the Quick Service Restaurant (QSR) segment, the brand has established itself as a market leader and one of the fastest-growing restaurant brands in the country with currently 59 stores across Nigeria and more to come.Kilimanjaro caters to the unique preference of the general populace in this part of sub-Saharan Africa for their local dishes. Our unique menu consists of select popular contemporary and Nigerian offerings. Items on our menu can also be found on dining tables in other African countries. The Kilimanjaro brand was born out of the quest to satisfy both the local and continental food cravings of our people. We deliver fresh, hot, and mouth-watering meals, pastries, sandwiches, and beverages to thousands of customers in the finest environment each day. Our restaurants stand out for their bright colors and lovely ambiance inviting you to dine-in or grab-and-go with the best quality meals.",
                publisher: {
                  "@type": "Organization",
                  name: "Kilimanjaro",
                },
                contactPoint: {
                  "@type": "ContactPoint",
                  telephone: "0700 5454 3663",
                  contactType: "customer support",
                },
              }),
            }}
          />

          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify({
                "@context": "https://schema.org",
                "@type": "WebSite",
                url: "https://kilimanjaro-restaurants.com",
                name: "Kilimanjaro",
                description:
                  "Kilimanjaro is one of the Sundry Foods’ restaurant brands, operating in the Quick Service Restaurant (QSR) segment, the brand has established itself as a market leader and one of the fastest-growing restaurant brands in the country with currently 59 stores across Nigeria and more to come.Kilimanjaro caters to the unique preference of the general populace in this part of sub-Saharan Africa for their local dishes. Our unique menu consists of select popular contemporary and Nigerian offerings. Items on our menu can also be found on dining tables in other African countries. The Kilimanjaro brand was born out of the quest to satisfy both the local and continental food cravings of our people. We deliver fresh, hot, and mouth-watering meals, pastries, sandwiches, and beverages to thousands of customers in the finest environment each day. Our restaurants stand out for their bright colors and lovely ambiance inviting you to dine-in or grab-and-go with the best quality meals.",
                publisher: {
                  "@type": "Organization",
                  name: "Kilimanjaro",
                },
                contactPoint: {
                  "@type": "ContactPoint",
                  telephone: "0700 5454 3663",
                  contactType: "customer support",
                },
              }),
            }}
          />

          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify({
                "@context": "https://schema.org",
                "@type": "Organization",
                name: "Kilimanjaro",
                url: "https://kilimanjaro-restaurants.com",
                contactPoint: {
                  "@type": "ContactPoint",
                  telephone: "0700 5454 3663",
                  contactType: "customer support",
                },
                address: {
                  "@type": "PostalAddress",
                  streetAddress: "23 Nzimiro street, Old GRA. Port Harcourt",
                  addressLocality: "Port Harcourt",
                  addressRegion: "Rivers",
                  addressCountry: "Nigeria",
                },
              }),
            }}
          />
        </Head>
            <section className="">
            
            <div className="hero">
               <h1 className="text-center">Do you want to eat</h1>
                    
                    <div className="food-cycler mx-auto mt-5">
                      <div
                        className={`food-cycler__inner ${animating ? "food-cycler__inner--exit" : "food-cycler__inner--enter"}`}
                      >
                        <img
                          src={current.image}
                          alt={current.name}
                          className="food-image img-fluid"
                          onError={(e) => {
                            e.target.src =
                              "https://placehold.co/300x300/f5f5f5/ccc?text=Food";
                          }}
                        />
                        {/* name label */}
                        <div className="food-cycler__label">
                          {/* SVG shape as background — stretches to fit the text */}
                          <img
                            src="/images/parallelogram.svg"
                            alt=""
                            aria-hidden="true"
                            className="food-cycler__label-bg img-fluid"
                          />
                          {/* text sits on top */}
                          <h2 className="food-cycler__label-text">
                            {current.name}
                          </h2>
                        </div>
                        <img
                          src="/images/icon/kili-spikes.svg"
                          alt=""
                          aria-hidden="true"
                          className="food-cycler__spike img-fluid"
                        />
                      </div>
                    </div>
                    <div className="d-flex justify-content-center order-btn ">
            <button
              className="btn "
        
                data-toggle="modal"
                      data-target="#orderTypeModal"
                      id="order-type-modal"
            >
              <span className="text">Order now</span>{" "}
              <span className="promo-card__arrow mt-2">
                <img
                  src="/images/icon/chevron-right-white.svg"
                  alt="send icon"
                  className="svg-icon ml-2"
                />
              </span>
            </button>
          </div>
                
                    <img
          className="left-banner-image"
          src="/images/left-banner-image.webp"
          alt="left-banner-image"
          height={200}
          width={100}
          decoding="async"
          fetchpriority="high"
        />
        <img
          className="right-banner-image"
          src="/images/right-banner-image.webp"
          alt="right-banner-image"
          width={100}
          height={200}
          decoding="async"
          fetchpriority="high"
        />
        
            </div>
          </section>
      

        {/* <Orders /> */}

        {/* <div ref={foodBannerRef} style={{ minHeight: "200px" }}>
        {foodBannerInView && (<>{
        isMobile && (<section>
              
    <div className="food-banner-2-wrapper d-block d-md-none mt-5">
  <Image
    src="/images/right-food-resized.webp"
    alt="food banner"
    layout="fill"
    objectFit="cover"
    sizes="(max-width: 768px) 412px, 1px"
    quality={60}
  />
</div>
            </section>)
       }</>)}
      </div> */}

        <section>
        
          <div className="tagsCarousel">
            <div className="tagsCarousel__track">
              <div className="tagsCarousel__group">
                {TAGS.map((tag, i) => (
                  <TagPill key={`a-${i}`} icon={tag.icon} label={tag.label} />
                ))}
              </div>
              <div className="tagsCarousel__group" aria-hidden="true">
                {TAGS.map((tag, i) => (
                  <TagPill key={`b-${i}`} icon={tag.icon} label={tag.label} />
                ))}
              </div>
            </div>
          </div>
        </section>

        <section>
          <div className="container promo-section">
            {/* Row 1: Latest Deals + Buy 2 Get 1 Free */}
            <div className="row">
              <div className="col-12 col-md-7">
                <div className="promo-card promo-card--red promo-card--deals">
                  <h3 className="text-white promo-card__heading">
                    Get More with the Latest Deals on Kilimanjaro
                  </h3>
                  <p className="text-white promo-card__text">
                    Enjoy more of the meals you love without stretching your
                    pocket. Check out our latest deals and find something
                    delicious to enjoy.
                  </p>
                  <button
                    className="promo-card__link "
                    
                      data-toggle="modal"
                      data-target="#orderTypeModal"
                      id="order-type-modal"
                  >
                    Order Now{" "}
                    <span className="promo-card__arrow mt-1">
                      {" "}
                      <img
                        src="/images/icon/arrow-right-red.svg"
                        alt="chevron right"
                      />
                    </span>
                  </button>
                </div>
              </div>

              <div className="col-12 col-md-5 d-none d-md-block">
                <div className="promo-card__offer-image">
                  <img
                    src="/images/promo-img.webp"
                    alt="Buy 2 get 1 free promotion"
                    className="img-fluid promo-card__offer-photo"
                    loading="lazy"
                  />
                  <img
                    src="/images/icon/ribbon.svg"
                    alt=""
                    aria-hidden="true"
                    className="promo-card__ribbon"
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Row 2: Find a Restaurant Near You */}

          <div className=" container promo-section">
            <div className="row  ">
              <div className="col-12 col-md-7 d-none d-md-block">
                <img
                  src="/images/location-img-new.webp"
                  alt="Kilimanjaro restaurant storefront"
                  className="img-fluid location-media"
                  loading="lazy"
                />
              </div>
              <div className="col-12 col-md-5">
                <div className=" promo-card promo-card__content promo-card--deals">
                  <h3 className="promo-card__header">
                    Find a Kilimanjaro Restaurant Near You
                  </h3>
                  <p className="promo-card__text">
                    Bring your family, meet up with friends, or have your next
                    outing at a Kilimanjaro Restaurant close to you. Enjoy a
                    mouthwatering variety of meals and a memorable dining
                    experience at Kilimanjaro Restaurants.
                  </p>
                  <button
                    className="btn mt-5 promo-card__btn"
                    onClick={(e) => routeToLocation(e)}
                  >
                    <span className="text ">Find Location </span>
                    <span className="promo-card__arrow">
                      <img
                        src="/images/icon/send.svg"
                        alt="send icon"
                        className="svg-icon ml-2"
                      />
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Row 3: Gift Cards */}
          <div className="container promo-section">
            <div className="promo-card--yellow">
              <div className="row ">
                <div className="col-12 col-md-7  ">
                  <div className="promo-card promo-card__content promo-card--deals ">
                    <h3 className="promo-card__title promo-card__title--dark">
                      Give the Gift of a Good Meal
                    </h3>
                    <p className="promo-card__text">
                      Looking for a gift they'll actually enjoy? Send a
                      Kilimanjaro Gift Card and let them choose from their
                      favorite meals whenever they're ready.
                    </p>

                    <button
                      className="btn mt-5 mb-5 promo-card__btn "
                      onClick={(e) => routeToGiftcard(e)}
                    >
                      <span className="text ">Get a Gift Card</span>
                      <span className="promo-card__arrow">
                        <img
                          src="/images/icon/giftbox.svg"
                          alt="send icon"
                          className="svg-icon ml-2"
                        />
                      </span>
                    </button>
                  </div>
                </div>
                <div className="col-12 col-md-5 promo-card__media d-none d-md-block">
                  <img
                    src="/images/giftcard-trans.webp"
                    alt="Kilimanjaro gift cards"
                    className="img-fluid"
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="menu-carousel-section  promo-section">
            <div className="container">
              <div className="menu-carousel-section__heading text-center mb-5">
                <h2 className="menu-carousel-section__title">
                  What's on the menu at <br />
                  Kilimanjaro Restaurant?
                </h2>
                <p className="menu-carousel-section__subtitle">
                  There's something for every craving. Pick your favorite
                  <br className="d-none d-md-block" />
                  and get your next meal on its way.
                </p>
              </div>
            </div>

            {/* carousel — full width, outside container so it bleeds edge to edge */}
            <div className="menu-carousel">
              <div
                className="menu-carousel__track"
                ref={trackRef}
               
              >
                {items.map((item, index) => (
                  <div
                    key={`${item.id}-${index}`}
                    className="menu-carousel__card"
                  >
                    {/* red header bar */}
                    <div className="menu-carousel__card-header">
                      <span className="menu-carousel__card-name">
                        {item.name}
                      </span>
                      <span className="menu-carousel__card-arrow">
                        <img
                          src="/images/icon/arrow-right-white.svg"
                          alt="chevron right"
                        />
                      </span>
                    </div>

                    {/* food image */}
                   <div className="menu-carousel__card-img-wrap">
  <img
    src={item.image}
    alt={item.name}
    className="menu-carousel__card-img"
    onError={(e) => {
      e.currentTarget.src =
        "https://placehold.co/260x200/f5f5f5/ccc?text=Food";
    }}
  />

  <img
    src="/images/icon/path.svg"
    alt=""
    aria-hidden="true"
    className="menu-carousel__card-food-creek"
  />
</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-center order-btn ">
            <button
              className="btn "
        
                data-toggle="modal"
                      data-target="#orderTypeModal"
                      id="order-type-modal"
            >
              <span className="text">Order now</span>{" "}
              <span className="promo-card__arrow mt-2">
                <img
                  src="/images/icon/chevron-right-white.svg"
                  alt="send icon"
                  className="svg-icon ml-2"
                />
              </span>
            </button>
          </div>

          {/* Row 4: e-Wallet */}
          <div className="container promo-section">
            <div className="row ">
              <div className="col-12 col-md-5 promo-card__media d-none d-md-block">
                <img
                  src="/images/wallet-frame.webp"
                  alt="Kilimanjaro e-Wallet"
                  className="img-fluid"
                  loading="lazy"
                />
              </div>
              <div className="col-12 col-md-7 ">
                <div className="promo-card promo-card__content promo-card--deals">
                  <h3 className="promo-card__title promo-card__title--dark">
                    Make Paying for Your Favorite Meals Faster
                  </h3>
                  <p className="promo-card__text">
                    Keep funds in your Kilimanjaro e-Wallet and pay for your
                    favorite meals quickly and easily, without reaching for your
                    card every time.
                  </p>

                  <button
                    className="btn mt-5 promo-card__btn "
                    onClick={(e) => routeToWallet(e)}
                  >
                    <span className="text ">Fund Your Wallet</span>
                    <span className="promo-card__arrow">
                      <img
                        src="/images/icon/wallet-trans.svg"
                        alt="send icon"
                        className="svg-icon ml-2"
                      />
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Row 5: Mobile App */}
          <div className="container promo-section">
            <div className="promo-card--red">
              <div className="row">
                <div className="col-12 col-md-7 ">
                  <div className="promo-card promo-card__content promo-card--deals">
                    <h3 className="promo-card__title">
                      Get More with the Kilimeals Mobile App
                    </h3>
                    <p className="promo-card__text text-white">
                      Enjoy a faster way to order your favorite meals, reorder
                      in seconds, track your delivery and get special offers
                      made for Kilimeals mobile app users.
                    </p>
                    <div className="promo-card__store-badges mt-5 mb-5">
                      <a
                        href="https://play.google.com/store/apps/details?id=com.kilimanjaro.kilimeals&pli=1"
                        className="promo-card__store-badge mr-2"
                      >
                        <img
                          src="/images/icon/android-badge.svg"
                          alt="Get it on Google Play"
                          className="promo-card__badge-icon"
                          
                        />
                      </a>
                      <a
                        href="https://apps.apple.com/us/app/kilimeals/id1571917847"
                        className="promo-card__store-badge ml-2"
                      >
                        <img
                          src="/images/icon/ios-badge.svg"
                          alt="Download on the App Store"
                          className="promo-card__badge-icon"
                          
                        />
                      </a>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-5 promo-card__media d-none d-md-block">
                  <div className="promo-card__media">
                    <img
                      src="/images/app-frame.webp"
                      alt="Kilimeals mobile app"
                      className="img-fluid "
                      loading="lazy"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="container ">
            <div className="article-section ">
              <h2 className="article-header ">Bites, Stories & Everything Kili</h2>
              {blogs.length > 0 && (
                <div className="blog-post-grid mt-4">
                  {blogs.slice(0, 3).map((blog) => (
                    <PostCard key={blog.id} post={blog} />
                  ))}
                </div>
              )}
            </div>
          </div>
      
<div
  className="modal fade"
  id="orderTypeModal"
  tabIndex="-1"
  role="dialog"
  aria-labelledby="orderTypeModalLabel"
  data-backdrop="static"
  data-keyboard="false"
>
  <div className="modal-dialog modal-dialog-centered" role="document">
    <div className="modal-content p-4">
      {/* Close icon */}
      <button
        type="button"
        className="order-type-modal__close"
        data-dismiss="modal"
        aria-label="Close"
      >
        <img src="/images/x-icon-grey.png" alt="" />
      </button>

      <div className="modal-body" id="orderTypeModalLabel">
       

        <HeaderContent cities={cities} />

        <a
          href="#"
          className="text-center d-block text-danger"
          data-dismiss="modal"
          aria-label="Close"
          id="closeModal"
          onClick={(e) => e.preventDefault()}
        >
          Close
        </a>
      </div>
    </div>
  </div>
</div>
        </section>
      </Layout>
    </>
  );
};
function TagPill({ icon, label }) {
  return (
    <div className="tagsCarousel__pill">
      <span className="tagsCarousel__pillIcon">
        {" "}
        <img src={icon} alt="tags" width={40} height={35} />
      </span>
      <span className="tagsCarousel__pillLabel">{label}</span>
    </div>
  );
}

export default Home;
